import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import {
  Sun,
  Sparkles,
  Scissors,
  User,
  Wind,
  Activity,
  Calendar,
  ClipboardList,
  Users,
  CreditCard,
  Package,
  TrendingUp,
  ArrowRight
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import BotonVolver from './BotonVolver';
import BotonWhatsApp from './BotonWhatsApp';

export default function Rgsesiones() {
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const idealItems = [
    { name: t("rgsesiones.ideal-1"), icon: Sun },
    { name: t("rgsesiones.ideal-2"), icon: Sparkles },
    { name: t("rgsesiones.ideal-3"), icon: Scissors },
    { name: t("rgsesiones.ideal-4"), icon: User },
    { name: t("rgsesiones.ideal-5"), icon: Wind },
    { name: t("rgsesiones.ideal-6"), icon: Activity },
  ];

  const featureItems = [
    { title: t("rgsesiones.feature-1"), icon: Calendar },
    { title: t("rgsesiones.feature-2"), icon: ClipboardList },
    { title: t("rgsesiones.feature-3"), icon: Users },
    { title: t("rgsesiones.feature-4"), icon: CreditCard },
    { title: t("rgsesiones.feature-5"), icon: Package },
    { title: t("rgsesiones.feature-6"), icon: TrendingUp },
  ];

  return (
    <div className="min-h-screen pb-20 bg-[#050505] text-zinc-100 font-sans selection:bg-zinc-500/30">
      {/* Back Button */}
      <BotonVolver text={t("rgsesiones.volver")} />

      <main className="relative">
        {/* Background Decorative Elements */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-gradient-to-b from-zinc-800/10 to-transparent pointer-events-none" />

        {/* Hero Section */}
        <section className="relative pt-32 pb-10 px-6">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 className="text-6xl md:text-7xl font-messina tracking-wide text-white mb-8 leading-none">
              {t("rgsesiones.title")}
            </h1>
            <p className="text-xl md:text-2xl text-zinc-400 font-light mb-12 max-w-2xl mx-auto leading-relaxed">
              {t("rgsesiones.subtitle")}
            </p>
            <BotonWhatsApp
              text={t("rgsesiones.visit-btn")}
              message="¡Hola! Me interesa obtener más información sobre el Sistema de RG Sesiones."
            />
          </div>
        </section>

        {/* Ideal For Section (Grid of Cards) */}
        <section className="py-5 px-6">
          <div className="container mx-auto max-w-6xl">
            <div className="mb-12 flex flex-col items-center">
              <h2 className="text-3xl md:text-4xl font-messina tracking-wide text-white mb-4">
                {t("rgsesiones.ideal-title")}
              </h2>
              <div className="h-1 w-20 bg-zinc-700 rounded-full" />
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {idealItems.map((item, index) => (
                <div key={index} className="group bg-zinc-900/40 border border-zinc-800/50 p-6 rounded-2xl flex flex-col items-center justify-center gap-4 hover:bg-zinc-800/40 transition-all duration-500 hover:border-zinc-600 hover:-translate-y-1">
                  <div className="w-12 h-12 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 group-hover:text-white transition-colors duration-500">
                    <item.icon className="w-6 h-6" />
                  </div>
                  <span className="text-sm font-light tracking-wide text-zinc-300 group-hover:text-white text-center">
                    {item.name}
                  </span>
                </div>
              ))}
            </div>

            <p className="mt-12 mb-4 text-center text-zinc-500 text-lg max-w-2xl mx-auto font-light italic border-t border-zinc-900 pt-8">
              "{t("rgsesiones.ideal-7")}"
            </p>
          </div>
        </section>

        {/* Features Section (Detailed Grid) */}
        <section className="py-10 bg-zinc-900/20 px-6 border-y border-zinc-900">
          <div className="container mx-auto max-w-6xl">
            <div className="mb-8 flex flex-col items-center">
              <h2 className="text-3xl md:text-4xl font-messina tracking-wide text-white mb-4">
                {t("rgsesiones.features-title")}
              </h2>
              <div className="h-1 w-20 bg-zinc-700 rounded-full" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {featureItems.map((feature, index) => (
                <div key={index} className="flex gap-5 p-2 group transition-all duration-300">
                  <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-zinc-900 border border-zinc-800 flex items-center justify-center text-zinc-500 group-hover:text-white group-hover:border-zinc-600 transition-all duration-300">
                    <feature.icon className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col justify-center">
                    <h3 className="text-lg font-light text-zinc-100 group-hover:text-white transition-colors">
                      {feature.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
